class DiagnosisResponse {
    public CodeCIM: string;
    public DescriptionLongue: string;
}

export { DiagnosisResponse };
